module.exports = false;



//////////////////
// WEBPACK FOOTER
// /Volumes/Projects/WellBrain_Azure_Web/node_modules/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = polyfills